export default {
  Employer: {
    required: 'Employer is required'
  },
  Contractor: {
    required: 'Contractor is required'
  },
  contractManager: {
    required: 'Commercial Contract Manager is required'
  },
  priceBreakdown: {
    required: 'Contract Price Breakdown is required',
    url: 'Contract Price Breakdown need to be valid URL address',
    vattenfallUrl: 'It is not valid Vattenfall SharePoint address'
  },
  packageManager: {
    required: 'Package Manager is required'
  },
  projectController: {
    required: 'Project Controller is required'
  },
  Project: {
    required: 'Field is required'
  },
  package: {
    required: 'Package is required'
  },
  contractName: {
    required: 'Contract Name is required'
  },
  contractType: {
    required: 'Type is required'
  },
  signedPrice: {
    required: 'Signed Price is required',
    numeric: 'Signed Price needs to be a number',
    minValue: 'Signed Price needs to be higher than 0'
  },
  companyName: {
    required: 'Company Name is required',
    maxLength: 'Company Name is to long'
  },
  street: {
    required: 'Street is required',
    maxLength: 'Street is to long'
  },
  houseNumber: {
    required: 'House Number is required',
    maxLength: 'House Number is to long'
  },
  zipCode: {
    required: 'Zip Code is required',
    maxLength: 'ZipCode is to long'
  },
  city: {
    required: 'City is required',
    maxLength: 'City name is to long'
  },
  state: {
    required: 'State is required',
    maxLength: 'State name is to long'
  },
  status: {
    required: 'Status is required'
  },
  sapVendorNumber: {
    required: 'SAP Vendor Number is required'
  },
  url: {
    required: 'URL is required',
    url: 'It is not valid URL address',
    vattenfallUrl: 'It is not valid Vattenfall SharePoint address'
  },
  name: {
    required: 'Name is required',
    maxLength: 'Name is too long.'
  },
  description: {
    maxLength: 'Description is too long.'
  },
  purchaseOrder: {
    maxLength: 'Order number is too long.'
  },
  subMilestones: {
    sumLowerThan: 'Sum of sub milestones amount needs to be lower than milestone amount'
  },
  comment: {
    maxLength: 'Value is too long.'
  },
  paymentCertificate: {
    maxLength: 'Value is too long.'
  },
  paymentAmountCents: {
    required: 'Payment is required',
    decimal: 'Amount should be a number',
    minValue: 'Amount must be higher than 0',
    maxValueAsSumOfSubMilestones: 'Milestone amount cannot be lower than sub milestones amounts',
    maxValueAsValueOfPart: 'Amount is higher than value remaining in milestone'
  },
  percentOfContractPrice: {
    decimal: 'Percent should be a number',
    minValue: 'Percent must be higher than 0',
    maxValue: 'Percent must be lower than 100'
  },
  percentOfMilestone: {
    required: 'Percent is required',
    decimal: 'This should be a number',
    minValue: 'Percent must be higher than 0'
  },
  cumulativePercentOfAcceptedPrice: {
    numeric: 'This should be a number',
    minValue: 'Percent must be higher than 0',
    maxValue: 'Percent must be lower than 100'
  },
  invoiceReference: {
    required: 'Invoice Reference Number is required',
    maxLength: 'Value is too long.'
  },
  applicationDate: {
    required: 'Application date is required'
  },
  paymentMilestones: {
    required: 'Please choose at list one milestone'
  },
  paymentPart: {
    required: 'Select part of milestone',
    decimal: 'Select part of milestone'
  },
  workflow: {
    required: 'Please choose workflow for application'
  },
  originalDate: {
    required: 'Please select date',
    date: 'Original milestone date is incorrect'
  },
  forecastedDate: {
    date: 'Forecasted milestone date is incorrect'
  },
  expectedInvoiceDate: {
    date: 'Expected invoice date is incorrect'
  },
  expectedPaymentDate: {
    date: 'Expected payment date is incorrect'
  },
  signatureDate: {
    required: 'Please select date'
  },
  commencementDate: {
    required: 'Please select date'
  },
  completionTime: {
    required: 'Please select date'
  },
  key: {
    required: 'Please select this field'
  },
  agreedValueCents: { },
  originalValueCents: { },
  parts: {
    required: 'Please add at least one part',
    minLength: 'Please add at least one part',
    sumEqual: 'Please calculate again. Sum of shares must be equal 100%'
  },
  ratio: {
    required: 'Share value is required'
  },
  areas: {
    required: 'Select at least one area',
    minLength: 'Select at least one area'
  },
  area: {
    required: 'Area is required'
  },
  code: {
    required: 'Code is required'
  },
  user: {
    required: 'Please select user'
  },
  project: {
    required: 'Please select project'
  },
  no: {
    required: 'Number field is required',
    maxLength: 'Number must not exceed 10 characters.'
  },
  stage: {
    required: 'Stage is required',
    maxValue: 'Stage is required',
    minValue: 'Stage is required',
    integer: 'Stage is required'
  },
  receivedDate: {
    required: 'Date is required',
    date: 'Date is incorrect'
  },
  obligorName: {
    maxLength: 'obligor name is too long'
  },
  beneficiaryName: {
    maxLength: 'Beneficiary name is too long'
  },
  guarantorName: {
    maxLength: 'Guarantor name is too long'
  },
  guarantorRating: {
    maxLength: 'Rating is too long'
  },
  guarantorContractRating: {
    maxLength: 'Rating is too long'
  },
  startDate: {
    date: 'Date is incorrect'
  },
  expiryDate: {
    date: 'Date is incorrect'
  },
  securedAmountPercent: {
    decimal: 'Percent must be a number',
    maxValue: 'Cannot be more then 100%'
  },
  physicalStorage: {
    requiredForField: 'Physical Storage is required',
    maxLength: 'Value is too long'
  },
  externalContact: {
    maxLength: 'Contact is too long'
  },
  returnAddress: {
    maxLength: 'Address is too long'
  },
  sendBack: {
    maxLength: 'Value is too long'
  },
  documentUrl: {
    url: 'It is not valid URL address',
    vattenfallUrl: 'It is not valid Vattenfall SharePoint address',
    requiredWhenExpiryDate: 'Document is required when expiry date present'
  },
  signedPriceCents: {
    required: 'Signed Contract Price is required',
    minValue: 'Signed Contract Price must be higher than 0',
    numeric: 'Signed Contract Price must be a number'
  },
  totalValueCents: {
    required: 'Total Value is required',
    minValue: 'Total Value must be higher than 0'
  },
  valueCents: {
    required: 'Overall Cap on LDs is required',
    minValue: 'Overall Cap on LDs must be higher than 0'
  },
  valuePercent: {
    minValue: 'Percent value must be higher than 0'
  },
  milestoneName: {
    required: 'Milestone Name is required',
    maxLength: 'Milestone Name is too long.'
  }
}
